export default __webpack_public_path__ + "static/media/13.cc9cef7e.svg";